// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {Text} from '@pub/comp/text';
import {CP_URL} from '@pub/constants.js';
import '@pub/css/error.less';

const CODES = {
    404: 'Resource is not found',
    generic: 'Something went wrong',
};

export function Error({className, code}){
    let text = CODES[code] || CODES.generic;
    if (code)
        text = `${code} | ${text}`;
    return <div className={cn('sdk-error', className)}>
      <div className="se-wrap">
        <Text.xxl className="se-text" mono>{text}</Text.xxl>
        {code==404&&<a className="se-link" href={CP_URL}>
          <Text.xs className="se-link-text" mono span>
            Get me back to dashboard</Text.xs>
        </a>}
      </div>
    </div>;
}
